import { render } from "./level-update-modal-note.vue?vue&type=template&id=483550c1&scoped=true&ts=true"
import script from "./level-update-modal-note.vue?vue&type=script&lang=ts"
export * from "./level-update-modal-note.vue?vue&type=script&lang=ts"

import "./level-update-modal-note.vue?vue&type=style&index=0&id=483550c1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483550c1"]])

export default __exports__